import { render, staticRenderFns } from "./TemplateEmailForm.vue?vue&type=template&id=3659cb1b&scoped=true"
import script from "./TemplateEmailForm.vue?vue&type=script&lang=ts"
export * from "./TemplateEmailForm.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEmailForm.vue?vue&type=style&index=0&id=3659cb1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3659cb1b",
  null
  
)

export default component.exports